import FlipLeaveAudit from './src/main';

/* istanbul ignore next */
FlipLeaveAudit.install = function(Vue) {
  Vue.component(FlipLeaveAudit.name, FlipLeaveAudit);
};

export default FlipLeaveAudit;
